import { Ng2StateDeclaration } from '@uirouter/angular';

export const airtrfx: Ng2StateDeclaration = {
    name: 'airtrfx.**',
    url: '/airtrfx',
    loadChildren: () => import('./root/airtrfx.root.module').then(m => m.Ng2AirtrfxRootModule)
};